module.exports = __webpack_public_path__ + "static/follow-us-video-0cda281bc033d522227090527e0e5a3c.jpg";